import { jsx as _jsx } from "react/jsx-runtime";
import { ChartPresetsFilter } from './chart_presets_filter.component';
import { ChartQueryFilter } from './chart_query_filter.component';
export const ChartFilterModal = ({ isOpen, onClose, applyFilters, filterData, initialSelectedOptions, logReportEvent, }) => {
    if (!filterData) {
        return null;
    }
    if (filterData.type === 'query') {
        return (_jsx(ChartQueryFilter, { isOpen, onClose, applyFilters, filterData, initialSelectedOptions, logReportEvent }));
    }
    return _jsx(ChartPresetsFilter, { isOpen, onClose, applyFilters, filterData, initialSelectedOptions });
};
